import React from 'react';
import { canMutateCatalogItem, canDuplicateCatalogItem, ownerLevelLabel } from '../utils/catalogOwnership';

/** True when item is considered active/enabled for toggle label. */
const isItemActive = (item) => {
  if (!item) return false;
  if (typeof item.isActive === 'boolean') return item.isActive;
  if (typeof item.isEnabled === 'boolean') return item.isEnabled;
  return true;
};

const CatalogItemActions = ({
  portal,
  item,
  onEdit,
  onDelete,
  onDuplicate,
  onToggle,
  toggleLabel
}) => {
  const mutate = canMutateCatalogItem(portal, item);
  const dup = canDuplicateCatalogItem(portal, item);
  const active = isItemActive(item);
  const defaultToggleLabel = active ? 'Deactivate' : 'Activate';

  return (
    <div className="card-actions">
      {mutate && onToggle && (
        <button type="button" className="btn btn-sm btn-secondary" onClick={() => onToggle(item)}>
          {toggleLabel || defaultToggleLabel}
        </button>
      )}
      {mutate && onEdit && (
        <button type="button" className="btn btn-sm btn-secondary" onClick={() => onEdit(item)}>
          Edit
        </button>
      )}
      {mutate && onDelete && (
        <button type="button" className="btn btn-sm btn-danger" onClick={() => onDelete(item._id)}>
          Remove
        </button>
      )}
      {dup && onDuplicate && (
        <button type="button" className="btn btn-sm btn-primary" onClick={() => onDuplicate(item)}>
          Duplicate
        </button>
      )}
      {!mutate && (
        <span
          className="ownership-badge"
          title="Inherited — Duplicate to edit your own copy"
          style={{ fontSize: 11 }}
        >
          {ownerLevelLabel(item)}
        </span>
      )}
    </div>
  );
};

export default CatalogItemActions;
export { isItemActive };
